export const AppConstant ={
    PAGES:{
        LOGIN:'login',
        DASHBOARD:'dashboard',
    }
}